import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { HttpService } from '../../services/http-service';
import { ITranslation } from '../../models/translations/translations';
import { Utility } from '../../helpers/utility';

@Component({
  selector: 'position-image-guide-modal',
  templateUrl: 'position-image-guide-modal.html',
})
export class PositionImageGuideModal {
  isTouchDevice: boolean;

  get t(): ITranslation {
    return this.httpService.getTransation();
  }

  constructor(
    public dialogRef: MatDialogRef<PositionImageGuideModal>,
    public httpService: HttpService
  ) {
    this.isTouchDevice = Utility.hasTouchScreen();
  }

  onGotIt(): void {
    this.dialogRef.close(true);
  }

  onClose(): void {
    this.dialogRef.close(false);
  }
}

